customElements.define(
  "collapsible-container",
  class Openable extends HTMLElement {
    constructor() {
      super();

      this.toggleContainer = this.querySelector(
        ".collapsible-toggle-container"
      );

      if (!this.toggleContainer) return;

      this.toggleBtn = this.toggleContainer.querySelector(
        ".collapsible-toggle-btn"
      );
      this.contentContainer = this.querySelector(
        ".collapsible-content-container"
      );

      this.toggleContainer.addEventListener("click", () =>
        this.toggleContainerVisibility()
      );

      if (this.classList.contains("collapsible-force-open")) {
        this.toggleContainerVisibility();
      }
    }

    toggleContainerVisibility() {
      if (!this.contentContainer) return;

      // Select all opened collapsibles
      const openedCollapsibleBtns =
        document.querySelectorAll(".collapsible-open");

      // Close them (should be 1)
      openedCollapsibleBtns.forEach((btn) => {
        const collapsible = btn.closest("collapsible-container");
        const container = collapsible.querySelector(
          ".collapsible-content-container"
        );

        if (this.contentContainer.id === container.id) return;

        container.style.maxHeight = 0;
        container.style.marginBottom = "0";

        btn.classList.remove("collapsible-open");
      });

      if (this.toggleBtn.classList.contains("collapsible-open")) {
        this.contentContainer.style.maxHeight = 0;
        this.contentContainer.style.marginBottom = "0";
      } else {
        this.contentContainer.style.maxHeight = `${this.contentContainer.scrollHeight}px`;
        this.contentContainer.style.marginBottom = "1rem";
      }

      this.toggleBtn.classList.toggle("collapsible-open");
    }
  }
);
